import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthState } from 'src/app/states/auth.state';
import { PushService } from 'src/app/services/push.service';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { FlexLayoutComponent } from '../flex-layout/flex-layout.component';

@Component({
  selector: 'app-push-activator',
  templateUrl: './push-activator.component.html',
  styleUrls: ['./push-activator.component.scss']
})
export class PushActivatorComponent implements OnInit {
  status: string;
  user: any;

  constructor(private pushService: PushService, private store: Store, private spinner: SpinnerService,
    private sharedService: SharedService) { }

  ngOnInit(): void {
    if (!this.sharedService.isBrowser) return;
    AuthState.user$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(user => {
        this.user = user;
        this.load();
      });
    this.load();
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private load() {
    if (this.pushService.isSupported) {
      this.pushService.status$.subscribe(status => {
        this.status = status || 'messaging/permission-default';
        if (status == 'messaging/permission-allowed' && !this.user?.HasOverduePush)
          delete this.status;
        this.spinner.show('push-checking');
      });
    }
  }

  async requestPermission() {
    await this.pushService.requestPermission();
    this.load();
  }

  openNotificationPanel() {
    this.sharedService.eventBus.emit(FlexLayoutComponent.events.notificationPanel);
  }
}
